import { createAction } from '@reduxjs/toolkit';

export const addDynamicDate = createAction('contacts/filter');
